/**
 * Check if the current user has admin role
 */
export const isAdmin = (user: any): boolean => {
  const roles = user?.profile?.role;
  if (!roles || !Array.isArray(roles)) return false;
  return roles.some((role: any) => role?.name === 'Admin');
};

/**
 * Check if the current user's email is in the authorized list, temporary as requested by Edo.
 */
export const isAuthorizedEmail = (user: any): boolean => {
  const email = user?.profile?.email || user?.profile?.preferred_username || '';
  return (
    email === 'edo@napster.com' ||
    email === 'abhi@napster.com' ||
    email === 'abhi@touchcast.com'
  );
};

/**
 * Check if the current user can update contributor media
 * Combines admin role check and email authorization
 */
export const canUpdateContributorMedia = (user: any): boolean => {
  return isAdmin(user) && isAuthorizedEmail(user);
};

/**
 * Extract initials from email address when first/last name are not available
 * Examples:
 * - john.doe@gmail.com → JD
 * - john_doe-smith@company.com → JD
 * - anna.maria.smith@… → AM
 * - john1987@… → JO
 * - user_123@… → US
 */
export const getInitialsFromEmail = (email: string): string => {
  if (!email) return 'U';

  // Extract the part before @
  let localPart = email.split('@')[0];
  if (!localPart) return 'U';

  // Remove everything after + (email aliasing - ignore the part after +)
  localPart = localPart.split('+')[0];

  // Split by common separators: ., _, -
  const parts = localPart.split(/[._-]/).filter((part) => part.length > 0);

  // Filter out purely numeric parts
  const alphabeticParts = parts.filter(
    (part) => !/^\d+$/.test(part) && /[a-zA-Z]/.test(part),
  );

  if (alphabeticParts.length >= 2) {
    // If we have at least 2 alphabetic parts, use first letter of first two parts
    return `${alphabeticParts[0].charAt(0)}${alphabeticParts[1].charAt(
      0,
    )}`.toUpperCase();
  } else if (alphabeticParts.length === 1) {
    // If only one alphabetic part, use first two letters
    const part = alphabeticParts[0];
    if (part.length >= 2) {
      return `${part.charAt(0)}${part.charAt(1)}`.toUpperCase();
    } else {
      return part.charAt(0).toUpperCase();
    }
  } else if (parts.length > 0) {
    // Fallback: if no alphabetic parts but we have parts, use first two letters of first part
    const part = parts[0];
    if (part.length >= 2) {
      return `${part.charAt(0)}${part.charAt(1)}`.toUpperCase();
    } else {
      return part.charAt(0).toUpperCase();
    }
  }

  return 'U';
};
